

export const GUEST_EXPLORER_OFFRES_INITIATE_FETCH_LISTE_OFFRES = 'GUEST_EXPLORER_OFFRES_INITIATE_FETCH_LISTE_OFFRES';
export const GUEST_EXPLORER_OFFRES_FETCH_LISTE_OFFRES_START = 'GUEST_EXPLORER_OFFRES_FETCH_LISTE_OFFRES_START';
export const GUEST_EXPLORER_OFFRES_FETCH_LISTE_OFFRES_SUCCESS = 'GUEST_EXPLORER_OFFRES_FETCH_LISTE_OFFRES_SUCCESS';
export const GUEST_EXPLORER_OFFRES_FETCH_LISTE_OFFRES_FAIL = 'GUEST_EXPLORER_OFFRES_FETCH_LISTE_OFFRES_FAIL';
export const GUEST_EXPLORER_OFFRES_FETCH_LISTE_OFFRES_RESET = 'GUEST_EXPLORER_OFFRES_FETCH_LISTE_OFFRES_RESET';